import {Components, ComponentService} from "../service/component";
import EVENTS from "../constants/events";
import {HistoryService} from "../service/history";
import EventsHandler from "../service/events";
import {ViewportService} from "../service/viewport";
import {AnimationService} from "../service/animation";

export class Application {

    public namespace: string;
    public components: ComponentService;
    public events: EventsHandler;
    public animations: AnimationService;
    public viewport: ViewportService;
    public history: HistoryService;

    constructor(components: ComponentService, namespace?: string, container?: HTMLElement) {
        if (namespace) {
            this.namespace = namespace;
        }
        this.setupEvents();
        this.setupHistory(this.events);
        this.setupAnimations();
        this.setupViewport(this.events);
        this.initComponents(components, container);
        Application.initFunctions();
        if (this.events) {
            this.events.addListener(
                EVENTS.APPLICATION_RELOAD,
                (container?: HTMLElement, namespaces?: string[]) => {
                    if (undefined === namespaces || -1 !== namespaces.indexOf(this.namespace)) {
                        this.initComponents(components, container)
                    }
                }
            );
        }
        this.history.start();
        this.viewport.start();
    }

    /**
     * This sets up components linking an instance of the object to each selector defined in the component array above
     */
    initComponents = (components: ComponentService, container?: HTMLElement) => {
        components.getComponents().forEach((component: Components) => {
            $(component.elements, container).each((key, element) => {
                let initialised = $(element).data('initialised') ? $(element).data('initialised') : [];
                if (!initialised.find((initialisedType: any) => initialisedType == component.componentName)) {
                    let object = new component.class(<HTMLElement>element);
                    if (this.events && typeof object.setEventHandler === 'function') {
                        object.setEventHandler(this.events);
                    }
                    if (this.animations && typeof object.setAnimationHandler === 'function') {
                        object.setAnimationHandler(this.animations);
                    }
                    if (this.history && typeof object.setHistoryHandler === 'function') {
                        object.setHistoryHandler(this.history);
                    }
                    if (component.callback) {
                        component.callback(object);
                    }
                    if (typeof object.init === 'function') {
                        object.init();
                    }
                    initialised.push(component.componentName);
                    $(element).data('initialised', initialised);
                }
            })
        });
    }

    /**
     * Set up the event object
     */
    setupEvents = () => {
        (<any>window).eventService = undefined === (<any>window).eventService ? new EventsHandler() : (<any>window).eventService;
        this.events = (<any>window).eventService;
    }

    /**
     * Set up the history object
     * @param events
     */
    setupHistory = (events: EventsHandler) => {
        (<any>window).historyService = undefined === (<any>window).historyService ? new HistoryService(events) : (<any>window).historyService;
        this.history = (<any>window).historyService;
    }

    /**
     * Set up the animation service
     */
    setupAnimations = () => {
        (<any>window).animationService = undefined === (<any>window).animationService ? new AnimationService() : (<any>window).animationService;
        this.animations = (<any>window).animationService;
    }

    /**
     * Set up the history object
     * @param events
     */
    setupViewport = (events: EventsHandler) => {
        (<any>window).viewportService = undefined === (<any>window).viewportService ? new ViewportService(events) : (<any>window).viewportService;
        this.viewport = (<any>window).viewportService;
    }

    /**
     *
     */
    public static initFunctions() {
        $('.no-js').removeClass('no-js').addClass('js');
    }
}